export class HubspotTracker {
  /**
   * Class instantiation constructor, sets defaults and
   * initializes Hubspot
   * @param {Object} hubspotConfig - Hubspot account_id and enabled flag
   */
  constructor(hubspotConfig = {}) {
    this.hubspot = hubspotConfig;

    if (this.hubspot.enabled && this.hubspot.account_id) {
      this._loadScript(this.hubspot.account_id);
    }
  }

  /**
   * Manually fire a page view. In a JS-driven single-page app where we don't
   * get a full page reload we've got to manually tell hubspot that the page has
   * changed
   * @param {string} [url] - The current page url, if empty it'll just fire the page view
   *                         and hubspot will use the current url in the browser
   * @returns {Undefined}
   */
  trackPage(url) {
    const _hsq = (window._hsq = window._hsq || []);
    if (url) {
      _hsq.push(['setPath', url]);
    }

    _hsq.push(['trackPageView']);
  }

  /**
   * Stops tracking - If you've identified the user to hubspot
   * the only way to disassociate a user is to remove the consent cookies
   * otherwise you've got the risk of multiple people being identified as the
   * same contact in Hubspot on computers where different people may log into
   * the app
   * @returns {Undefined}
   */
  shutDown() {
    const _hsp = (window._hsp = window._hsp || []);
    _hsp.push(['revokeCookieConsent']);
  }

  /**
   * Insert the hubspot load script into the DOM, As soon as this is inserted
   * It'll automatically fire a trackPageView. So if you need to set up things
   * previous to that do it in the contructor above before this call.
   * @param {string} accountID - hubspot HubID/Account ID
   * @param {function} [onloadFn] - optional callback when the script is done loading
   * @returns {Undefined}
   */
  _loadScript(accountId, onloadFn) {
    // create the script html
    const script = document.createElement('script');
    script.defer = true;
    script.async = true;
    script.id = 'hs-script-loader';
    script.src = `https://js.hs-scripts.com/${accountId}.js`;

    // insert it before the first script tag on the page
    const el = document.getElementsByTagName('script')[0];
    el.parentNode.insertBefore(script, el);

    if (onloadFn) {
      script.onload = onloadFn;
    }
  }
}
